<template>
  <div class="page-wrap">

    <appointmentDetailModal
      v-if="appointmentDetailModalShow"
      v-on:closemodal="closeModal"
      :loading-data="loadingData"
      :has-data="hasData"
      :show-modal="appointmentDetailModalShow"
      :appointment-data="appointmentData"
      :index-num="currentIndex"
      :show-qr-code="false"
      :token="token"
      :payment-log="true"
    />

    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <div class="panel-header-left">
          <div class="panel-icon"><i class="fa fa-credit-card"></i></div>
          <div>
            <div class="panel-title">
              Payment Logs
              <span class="count-badge" v-if="pagination.total_records > 0">{{ pagination.total_records }}</span>
            </div>
            <div class="panel-sub">Transaction history for all card payments</div>
          </div>
        </div>
      </div>

      <!-- Toolbar -->
      <div class="toolbar">

        <!-- Server search -->
        <div class="search-box">
          <i class="fa fa-search"></i>
          <input type="text" placeholder="Search by appt no. or name…"
            v-model="search_text" @keypress.enter="searchReset" />
          <button v-if="search_text" class="search-clear" @click="search_text = ''; searchReset()">
            <i class="fa fa-times"></i>
          </button>
        </div>

        <!-- Service Provider (admin) -->
        <div class="ts-wrap" v-if="currentUser.u.is_admin" ref="spWrap" v-click-outside="closeSpDropdown">
          <div class="ts-input" @click="toggleSp">
            <span class="ts-val" v-if="!spOpen">{{ spLabel }}</span>
            <input v-if="spOpen" type="text" class="ts-search" v-model="spSearch"
              placeholder="Search provider…" ref="spInput" @keydown.esc="closeSpDropdown" />
            <i class="fa fa-chevron-down ts-arrow" :class="{ open: spOpen }"></i>
          </div>
          <div class="ts-dropdown" v-if="spOpen" :style="spDropStyle">
            <div class="ts-item" @click="selectSp('all')">All Service Providers</div>
            <div class="ts-item" v-for="(c, i) in filteredSp" :key="i" @click="selectSp(c.id)">{{ c.name }}</div>
            <div class="ts-empty" v-if="filteredSp.length === 0 && spSearch">No match</div>
          </div>
        </div>

        <!-- Location (admin) -->
        <div class="ts-wrap" v-if="currentUser.u.is_admin" ref="locWrap" v-click-outside="closeLocDropdown">
          <div class="ts-input" @click="toggleLoc">
            <span class="ts-val" v-if="!locOpen">{{ locLabel }}</span>
            <input v-if="locOpen" type="text" class="ts-search" v-model="locSearch"
              placeholder="Search location…" ref="locInput" @keydown.esc="closeLocDropdown" />
            <i class="fa fa-chevron-down ts-arrow" :class="{ open: locOpen }"></i>
          </div>
          <div class="ts-dropdown" v-if="locOpen" :style="locDropStyle">
            <div class="ts-item" @click="selectLoc('all')">All Locations</div>
            <div class="ts-item" v-for="(c, i) in filteredLoc" :key="i" @click="selectLoc(c.id)">{{ c.name }}</div>
            <div class="ts-empty" v-if="filteredLoc.length === 0 && locSearch">No match</div>
          </div>
        </div>

        <!-- Date range -->
        <input type="date" class="filter-date" v-model="date_from" />
        <input type="date" class="filter-date" v-model="date_to" />

        <!-- Status -->
        <select class="filter-select" v-model="status">
          <option value="all">All Statuses</option>
          <option value="Approval">Approved</option>
          <option value="Declined">Declined</option>
        </select>

        <button class="btn-search" @click="searchReset">
          <i class="fa fa-search"></i> Search
        </button>

        <!-- Client-side live filter -->
        <div class="search-box search-box-live">
          <i class="fa fa-filter"></i>
          <input type="text" placeholder="Filter results…" v-model="searchQuery" />
          <button v-if="searchQuery" class="search-clear" @click="searchQuery = ''">
            <i class="fa fa-times"></i>
          </button>
        </div>

      </div>

      <!-- Loading -->
      <div class="state-box" v-if="getLoadingData">
        <i class="fa fa-spinner fa-spin"></i>
        Loading payment logs…
      </div>

      <!-- Empty -->
      <div class="state-box" v-else-if="resultQuery.length === 0">
        <i class="fa fa-inbox"></i>
        No payment records found
      </div>

      <!-- Table -->
      <div class="table-wrap" v-else>
        <table class="pay-table">
          <thead>
            <tr>
              <th style="width:44px">#</th>
              <th style="min-width:140px">Transaction #</th>
              <th style="min-width:90px">App No.</th>
              <th style="min-width:140px">Date / Time</th>
              <th style="min-width:130px">Card Name</th>
              <th style="min-width:140px">Applicant</th>
              <th style="min-width:90px" class="col-right">Amount</th>
              <th style="min-width:130px">Location</th>
              <th style="min-width:110px">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in resultQuery" :key="index">
              <td class="col-num">{{ (pagination.current_page - 1) * 15 + index + 1 }}</td>
              <td class="col-txn">{{ item.card_reference }}</td>
              <td>
                <button class="btn-appt" @click="openAppointmentDetail(item.appointment, item.appt_token)">
                  {{ item.appointment }}
                </button>
              </td>
              <td class="col-date">{{ datetimeFormatAmPm(item.created_at) }}</td>
              <td>{{ item.log_data.name }}</td>
              <td>{{ item.applicant_name }}</td>
              <td class="col-right col-amount">${{ toFixedTwoDigit(item.log_data.amt) }}</td>
              <td class="col-location">{{ item.log_data.location }}</td>
              <td>
                <span class="status-badge" :class="statusClass(item.log_data.resptext)">
                  {{ item.log_data.resptext }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="pagination-bar" v-if="pagination.total_page > 1">
        <span class="pg-info">
          Page {{ pagination.current_page }} of {{ pagination.total_page }}
          · {{ pagination.total_records }} records
        </span>
        <div class="pg-controls">
          <button class="pg-btn" :disabled="pagination.current_page === 1" @click="firstPage"><i class="fa fa-angle-double-left"></i></button>
          <button class="pg-btn" :disabled="pagination.current_page === 1" @click="previousPage"><i class="fa fa-angle-left"></i></button>
          <button v-for="p in visiblePages" :key="p" class="pg-btn" :class="{ active: p === pagination.current_page }" @click="selectedPage(p)">{{ p }}</button>
          <button class="pg-btn" :disabled="pagination.current_page === pagination.total_page" @click="nextPage"><i class="fa fa-angle-right"></i></button>
          <button class="pg-btn" :disabled="pagination.current_page === pagination.total_page" @click="lastPage"><i class="fa fa-angle-double-right"></i></button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import moment from "moment";
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import {
  FETCH_PAYMENT_LOG,
  FETCH_SELF_APPOINMENT,
  FETCH_SERVICES_CLIENTS
} from "@/core/services/store/actions.type";
import appointmentDetailModal from "@/components/frontend/modal/appointmentdetail";
import { mapGetters } from "vuex";

export default {
  components: { appointmentDetailModal },
  directives: {
    clickOutside: {
      bind(el, binding) {
        el._clickOutsideHandler = e => { if (!el.contains(e.target)) binding.value(e); };
        document.addEventListener("mousedown", el._clickOutsideHandler);
      },
      unbind(el) {
        document.removeEventListener("mousedown", el._clickOutsideHandler);
      }
    }
  },
  computed: {
    ...mapGetters(["currentUser", "getClients", "getSpClients"]),
    filteredSp() {
      const q = (this.spSearch || "").toLowerCase();
      const list = this.getClients || [];
      return q ? list.filter(c => c.name && c.name.toLowerCase().includes(q)) : list;
    },
    filteredLoc() {
      const q = (this.locSearch || "").toLowerCase();
      const list = this.getSpClients || [];
      return q ? list.filter(c => c.name && c.name.toLowerCase().includes(q)) : list;
    },
    spLabel() {
      if (this.serviceProviderOutlet === "all") return "All Service Providers";
      const c = (this.getClients || []).find(c => c.id === this.serviceProviderOutlet);
      return c ? c.name : "All Service Providers";
    },
    locLabel() {
      if (this.serviceOutlet === "all") return "All Locations";
      const c = (this.getSpClients || []).find(c => c.id === this.serviceOutlet);
      return c ? c.name : "All Locations";
    },
    visiblePages() {
      const pages = [];
      const cur = this.pagination.current_page;
      const total = this.pagination.total_page;
      for (let i = Math.max(1, cur - 2); i <= Math.min(total, cur + 2); i++) pages.push(i);
      return pages;
    },
    resultQuery() {
      const q = (this.searchQuery || "").toLowerCase().trim();
      if (!q) return this.payment_log;
      return this.payment_log.filter(item => {
        const terms = q.split(" ");
        return terms.every(v =>
          item.card_reference.toLowerCase().includes(v) ||
          (item.log_data.resptext || "").toLowerCase().includes(v) ||
          (item.log_data.location || "").toLowerCase().includes(v) ||
          (item.log_data.name || "").toLowerCase().includes(v) ||
          (item.applicant_name || "").toLowerCase().includes(v) ||
          item.appointment.toString().includes(v)
        );
      });
    }
  },
  data() {
    return {
      serviceProviderOutlet: "all",
      serviceOutlet: "all",
      spOpen: false, spSearch: "", spDropStyle: {},
      locOpen: false, locSearch: "", locDropStyle: {},
      searchQuery: "",
      search_text: "",
      status: "all",
      date_from: this.$moment(new Date()).format("YYYY-MM-DD"),
      date_to:   this.$moment(new Date()).format("YYYY-MM-DD"),
      getLoadingData: false,
      payment_log: [],
      pagination: {
        total_records: 0,
        total_page: 0,
        current_page: 1,
        per_page_data: 15,
        received_per_page_data: 15
      },
      appointmentDetailModalShow: false,
      loadingData: false,
      hasData: false,
      appointmentData: {},
      currentIndex: -1,
      token: "",
      breadCrumbs: [
        { id: 1, title: "Dashboard", route: "client.dashboard" },
        { id: 2, title: "Logs",      route: "" },
        { id: 3, title: "Payments",  route: "log.payment" }
      ]
    };
  },
  created() {
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
  },
  methods: {
    datetimeFormatAmPm(date) {
      if (!date) return "—";
      return moment(date).format("MM/DD/YYYY h:mm a");
    },
    toFixedTwoDigit(amount) {
      return parseFloat(amount || 0).toFixed(2);
    },
    statusClass(text) {
      if (!text) return "badge-neutral";
      const t = text.toLowerCase();
      if (t.includes("approv")) return "badge-green";
      if (t.includes("declin")) return "badge-red";
      return "badge-neutral";
    },
    toggleSp() {
      this.spOpen = !this.spOpen;
      if (this.spOpen) {
        this.spSearch = "";
        this.$nextTick(() => {
          if (this.$refs.spInput) this.$refs.spInput.focus();
          const wrap = this.$refs.spWrap;
          if (wrap) {
            const r = wrap.getBoundingClientRect();
            this.spDropStyle = { position: "fixed", top: (r.bottom + 4) + "px", left: r.left + "px", width: r.width + "px", zIndex: 9999 };
          }
        });
      }
    },
    closeSpDropdown() { this.spOpen = false; this.spSearch = ""; this.spDropStyle = {}; },
    selectSp(id) {
      this.serviceProviderOutlet = id;
      this.closeSpDropdown();
      this.loadServicesProvider();
    },
    toggleLoc() {
      this.locOpen = !this.locOpen;
      if (this.locOpen) {
        this.locSearch = "";
        this.$nextTick(() => {
          if (this.$refs.locInput) this.$refs.locInput.focus();
          const wrap = this.$refs.locWrap;
          if (wrap) {
            const r = wrap.getBoundingClientRect();
            this.locDropStyle = { position: "fixed", top: (r.bottom + 4) + "px", left: r.left + "px", width: r.width + "px", zIndex: 9999 };
          }
        });
      }
    },
    closeLocDropdown() { this.locOpen = false; this.locSearch = ""; this.locDropStyle = {}; },
    selectLoc(id) { this.serviceOutlet = id; this.closeLocDropdown(); },
    loadServicesProvider() {
      this.serviceOutlet = "all";
      this.$store.dispatch(FETCH_SERVICES_CLIENTS, this.serviceProviderOutlet);
    },
    closeModal() {
      this.appointmentDetailModalShow = false;
    },
    openAppointmentDetail(appId, token) {
      this.appointmentDetailModalShow = true;
      this.loadingData = true;
      this.$store.dispatch(FETCH_SELF_APPOINMENT, { token, appointment_id: appId })
        .then(res => {
          this.loadingData = false;
          this.hasData = res.hasData;
          this.appointmentData = res.data;
          this.token = token;
        })
        .catch(() => { this.loadingData = false; });
    },
    searchReset() {
      this.pagination.current_page = 1;
      this.Search();
    },
    Search() {
      this.getLoadingData = true;
      this.searchQuery = "";
      this.$store.dispatch(FETCH_PAYMENT_LOG, {
        date_from:        this.date_from,
        date_to:          this.date_to,
        page:             this.pagination.current_page,
        status:           this.status,
        search_text:      this.search_text,
        service_provider: this.serviceProviderOutlet,
        service_location: this.serviceOutlet
      })
        .then(res => {
          this.getLoadingData = false;
          this.payment_log = res.data;
          this.pagination.total_records = res.total_record;
          this.pagination.total_page    = res.page_range;
          this.pagination.received_per_page_data = res.data.length;
        })
        .catch(err => {
          this.getLoadingData = false;
          this.msg = err.error;
        });
    },
    selectedPage(n) { this.pagination.current_page = n; this.Search(); },
    nextPage()       { this.pagination.current_page++;   this.Search(); },
    lastPage()       { this.pagination.current_page = this.pagination.total_page; this.Search(); },
    firstPage()      { this.pagination.current_page = 1; this.Search(); },
    previousPage()   { this.pagination.current_page--;   this.Search(); }
  }
};
</script>

<style lang="scss" scoped>
$font: 'Segoe UI', sans-serif;
$blue: #389ad4;
$dark: #0d1b3e;
$border: #dde2ec;
$green: #276749;

.page-wrap {
  padding: 8px 0 80px;
  font-family: $font;
}

/* Panel */
.panel-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(13, 27, 62, 0.07);
  overflow: visible;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: #fafbfd;
  border-bottom: 1px solid #eef0f6;
  gap: 10px;
  flex-wrap: wrap;
}

.panel-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.panel-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: $blue;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

.panel-title {
  font-size: 14px;
  font-weight: 700;
  color: $dark;
  display: flex;
  align-items: center;
  gap: 8px;
}

.count-badge {
  font-size: 11px;
  font-weight: 600;
  color: #7a8499;
  background: #eef0f6;
  border-radius: 10px;
  padding: 1px 7px;
}

.panel-sub {
  font-size: 11px;
  color: #8a94a6;
  margin-top: 2px;
}

/* Toolbar */
.toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border-bottom: 1px solid #f0f3fa;
  flex-wrap: wrap;
}

.search-box {
  position: relative;
  flex: 1;
  min-width: 180px;
  max-width: 280px;

  i { position: absolute; left: 10px; top: 50%; transform: translateY(-50%); color: #a0aab8; font-size: 12px; pointer-events: none; }

  input {
    width: 100%;
    height: 36px;
    border: 1.5px solid $border;
    border-radius: 8px;
    padding: 0 30px 0 30px;
    font-size: 13px;
    font-family: $font;
    color: $dark;
    outline: none;
    background: #fff;
    transition: border-color 0.2s;

    &::placeholder { color: #b0bac9; }
    &:focus { border-color: $blue; box-shadow: 0 0 0 3px rgba(56,154,212,0.1); }
  }
}

.search-box-live {
  max-width: 200px;

  input { background: #f7f9fc; }
}

.search-clear {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  color: #a0aab8;
  cursor: pointer;
  font-size: 11px;
  padding: 0;

  &:hover { color: $dark; }
}

/* ── Type-and-select ── */
.ts-wrap {
  position: relative;
  min-width: 160px;
  max-width: 200px;
}

.ts-input {
  display: flex;
  align-items: center;
  height: 36px;
  border: 1.5px solid $border;
  border-radius: 8px;
  padding: 0 10px;
  background: #fff;
  cursor: pointer;
  gap: 6px;
  transition: border-color 0.2s;

  &:hover { border-color: $blue; }
  &:focus-within { border-color: $blue; box-shadow: 0 0 0 3px rgba(56,154,212,0.1); }
}

.ts-val {
  flex: 1;
  font-size: 12px;
  color: $dark;
  font-family: $font;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;
}

.ts-search {
  flex: 1;
  border: none;
  outline: none;
  font-size: 12px;
  color: $dark;
  font-family: $font;
  background: transparent;
  min-width: 0;

  &::placeholder { color: #b0bac9; }
}

.ts-arrow {
  font-size: 10px;
  color: #a0aab8;
  flex-shrink: 0;
  transition: transform 0.2s;
  pointer-events: none;

  &.open { transform: rotate(180deg); }
}

.ts-dropdown {
  position: fixed;
  background: #fff;
  border: 1.5px solid $border;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(13, 27, 62, 0.12);
  z-index: 9999;
  max-height: 210px;
  overflow-y: auto;
}

.ts-item {
  padding: 8px 12px;
  font-size: 12px;
  color: $dark;
  font-family: $font;
  cursor: pointer;
  white-space: normal;
  word-break: break-word;
  line-height: 1.4;
  transition: background 0.12s;

  &:hover { background: #f0f7fd; color: $blue; }
}

.ts-empty {
  padding: 10px 12px;
  font-size: 12px;
  color: #a0aab8;
  text-align: center;
}

.filter-select {
  height: 36px;
  border: 1.5px solid $border;
  border-radius: 8px;
  padding: 0 28px 0 10px;
  font-size: 12px;
  font-family: $font;
  color: $dark;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23a0aab8'/%3E%3C/svg%3E") no-repeat right 10px center;
  appearance: none;
  outline: none;
  cursor: pointer;
  max-width: 180px;
  transition: border-color 0.2s;

  &:focus { border-color: $blue; }
}

.filter-date {
  height: 36px;
  border: 1.5px solid $border;
  border-radius: 8px;
  padding: 0 10px;
  font-size: 12px;
  font-family: $font;
  color: $dark;
  background: #fff;
  outline: none;
  transition: border-color 0.2s;

  &:focus { border-color: $blue; }
}

.btn-search {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  border: none;
  background: $blue;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  transition: opacity 0.2s;

  i { font-size: 11px; }
  &:hover { opacity: 0.9; }
}

/* States */
.state-box {
  text-align: center;
  padding: 48px 24px;
  color: #a0aab8;
  font-size: 13px;

  i { font-size: 28px; display: block; margin-bottom: 10px; opacity: 0.45; }
}

/* Table */
.table-wrap { overflow-x: auto; }

.pay-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  font-family: $font;
  table-layout: auto;

  thead tr {
    background: #fff;
    border-bottom: 2px solid #eef0f8;

    th {
      padding: 9px 12px;
      font-size: 11px;
      font-weight: 700;
      color: #7a8499;
      text-transform: uppercase;
      letter-spacing: 0.4px;
      white-space: nowrap;
      text-align: left;

      &.col-right { text-align: right; }
    }
  }

  tbody tr {
    border-bottom: 1px solid #f5f7fa;
    transition: background 0.15s;

    &:last-child { border-bottom: none; }
    &:hover td { background: #f8fbff; }

    td {
      padding: 10px 12px;
      color: $dark;
      vertical-align: middle;
    }
  }
}

.col-num    { color: #a0aab8; font-size: 12px; }
.col-txn    { font-family: 'Courier New', monospace; font-size: 12px; color: #4a5568; }
.col-date   { font-size: 12px; color: #6b7280; white-space: nowrap; }
.col-amount { font-weight: 700; font-size: 13px; color: $dark; }
.col-right  { text-align: right; }
.col-location { font-size: 12px; color: #4a5568; }

/* Appt button */
.btn-appt {
  border: none;
  background: none;
  padding: 0;
  color: $blue;
  font-size: 13px;
  font-family: $font;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover { color: darken(#389ad4, 10%); }
}

/* Status badge */
.status-badge {
  display: inline-block;
  padding: 2px 9px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.2px;

  &.badge-green {
    background: #dcfce7;
    color: #166534;
  }
  &.badge-red {
    background: #fee2e2;
    color: #991b1b;
  }
  &.badge-neutral {
    background: #f1f5f9;
    color: #64748b;
  }
}

/* Pagination */
.pagination-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-top: 1px solid #f0f3fa;
  flex-wrap: wrap;
  gap: 10px;
}

.pg-info { font-size: 12px; color: #7a8499; }
.pg-controls { display: flex; align-items: center; gap: 4px; }

.pg-btn {
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: 1.5px solid $border;
  background: #fff;
  color: #4a5568;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  transition: all 0.15s;

  &:hover:not(:disabled) { border-color: $blue; color: $blue; }
  &:disabled { opacity: 0.35; cursor: default; }
  &.active { background: $blue; border-color: $blue; color: #fff; }
}
</style>
